'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingServiceV2 = void 0;
var tslib_1 = require("tslib");
var tracking_v2_interface_1 = require("./tracking-v2.interface");
var config_1 = require("../../config");
var events_1 = require("@gig/magic-sdk/dist/events");
var signup_1 = require("@gig/magic-sdk/dist/adapter/users/signup");
var getAmlStatus_1 = require("@gig/magic-sdk/dist/adapter/users/getAmlStatus");
var TrackingServiceV2 = /** @class */ (function () {
    function TrackingServiceV2() {
        this.user = null;
        this.balance = null;
        this.page = null;
        this.userAccounts = null;
        this.jurisdiction = 'MGA';
        this.previousPage = null;
        this.handlers = [];
    }
    TrackingServiceV2.prototype.onTrack = function (handler) {
        var _this = this;
        this.handlers.push(handler);
        return function () {
            _this.handlers.splice(_this.handlers.indexOf(handler), 1);
        };
    };
    TrackingServiceV2.prototype.track = function (event) {
        if (!event.hasOwnProperty('exp')) {
            var isPWA = Boolean(window.navigator.standalone ||
                window.matchMedia('(display-mode: standalone)').matches);
            event = tslib_1.__assign(tslib_1.__assign({}, event), { isPWA: isPWA });
        }
        this.handlers.forEach(function (handler) {
            try {
                handler(event);
            }
            catch (e) {
                console.error(e);
            }
        });
    };
    TrackingServiceV2.prototype.setPage = function (page) {
        if (page === null) {
            // reset page
            this.page = null;
            this.previousPage = null;
            return;
        }
        this.previousPage = this.page;
        this.page = page;
        this.updateUserDetails();
    };
    TrackingServiceV2.prototype.setUser = function (user) {
        this.user = user;
        this.updateUserDetails();
    };
    TrackingServiceV2.prototype.setBalance = function (balance) {
        this.balance = balance;
        this.updateUserDetails();
    };
    TrackingServiceV2.prototype.setUserAccounts = function (userAccounts) {
        this.userAccounts = userAccounts;
        this.updateUserDetails();
    };
    TrackingServiceV2.prototype.setJurisdiction = function (jurisdiction) {
        this.jurisdiction = jurisdiction;
        this.updateUserDetails();
    };
    TrackingServiceV2.prototype.setExperiments = function (identifiers) {
        this.track({ exp: identifiers });
    };
    /*
     * User activity events
     */
    TrackingServiceV2.prototype.trackPageView = function (page) {
        if (page) {
            this.setPage(page);
        }
        var pageInfo = this.getPageInfo();
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.PAGE_VIEW,
            eventAction: pageInfo.currentPage,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackLogin = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.LOGIN,
            eventAction: tracking_v2_interface_1.UserActivityAction.LOGGED_IN,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackFirstLogin = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.LOGIN,
            eventAction: tracking_v2_interface_1.UserActivityAction.FIRST_LOGIN,
            value: null,
            eventLabel: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackFailedLogin = function (_, error) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.LOGIN,
            eventAction: tracking_v2_interface_1.UserActivityAction.LOGIN_FAILED,
            eventLabel: error,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackLogout = function (statusCode) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.LOGIN,
            eventAction: tracking_v2_interface_1.UserActivityAction.LOGGED_OUT,
            eventLabel: this.convertSessionStatus(statusCode),
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackSelfExclusion = function (period) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.SELF_EXCLUSION,
            eventAction: period,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackCookieAcceptance = function (accepted) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.USER_ACTIVITY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.COOKIE_CONSENT,
            eventAction: accepted
                ? tracking_v2_interface_1.UserActivityAction.COOKIES_ACCEPTED
                : tracking_v2_interface_1.UserActivityAction.COOKIES_REJECTED,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    /*
     * Customer Balance Events
     */
    TrackingServiceV2.prototype.trackBalanceZero = function () {
        this.trackBalance(tracking_v2_interface_1.UserBalanceEventAction.ZERO);
    };
    TrackingServiceV2.prototype.trackBalanceNearZero = function () {
        this.trackBalance(tracking_v2_interface_1.UserBalanceEventAction.NEAR_ZERO);
    };
    /*
     * Games Events
     */
    TrackingServiceV2.prototype.trackEnterGame = function (gameInfo) {
        if (!this.user) {
            this.trackGame(gameInfo, tracking_v2_interface_1.GameEventAction.FREE_PLAY);
            return;
        }
        this.trackGame(gameInfo, tracking_v2_interface_1.GameEventAction.REAL_PLAY);
    };
    TrackingServiceV2.prototype.trackLeaveGame = function (gameInfo) {
        this.trackGame(gameInfo, tracking_v2_interface_1.GameEventAction.END_PLAY);
    };
    TrackingServiceV2.prototype.trackGameCategorySelect = function (categorySlug, categoryName) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.GAME_CATEGORY,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.LOBBY,
            eventAction: 'Select category',
            eventLabel: categorySlug,
            value: categoryName,
        };
        this.track(event);
    };
    /*
     * Registration
     */
    TrackingServiceV2.prototype.trackRegistrationStep = function (step, utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.REGISTER_FLOW,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.REGISTRATION,
            eventAction: step,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackChangeRegistrationPhoneNumber = function (utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.EDIT_PHONE, utm, btag);
    };
    TrackingServiceV2.prototype.trackResendActivationCode = function (utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.RESEND_CODE, utm, btag);
    };
    TrackingServiceV2.prototype.trackResendEmail = function (utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.RESEND_EMAIL, utm, btag);
    };
    TrackingServiceV2.prototype.trackRegistrationAttempt = function (_, utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.ATTEMPT, utm, btag);
    };
    TrackingServiceV2.prototype.trackRegistrationComplete = function (email, utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.ACCEPTED, utm, btag);
    };
    TrackingServiceV2.prototype.trackRegistrationConfirmed = function (utm, btag) {
        this.trackRegistrationAction(tracking_v2_interface_1.RegisterEventAction.CONFIRMED, utm, btag);
    };
    /*
     * Deposits
     */
    TrackingServiceV2.prototype.trackDepositIntent = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.DEPOSIT,
            eventAction: tracking_v2_interface_1.DepositEventAction.OPEN,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackDepositStarted = function (method) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.DEPOSIT,
            eventAction: tracking_v2_interface_1.DepositEventAction.STARTED,
            eventLabel: null,
            value: method,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackDepositAttempt = function (depositInfo) {
        this.trackDepositAction(tracking_v2_interface_1.DepositEventAction.ATTEMPT, depositInfo);
    };
    TrackingServiceV2.prototype.trackDeposit = function (depositInfo) {
        this.trackDepositAction(tracking_v2_interface_1.DepositEventAction.DEPOSIT, depositInfo);
    };
    TrackingServiceV2.prototype.trackDepositError = function (depositInfo) {
        this.trackDepositAction(tracking_v2_interface_1.DepositEventAction.ERROR, depositInfo);
    };
    TrackingServiceV2.prototype.trackFirstTimeDeposit = function (depositInfo) {
        this.trackDepositAction(tracking_v2_interface_1.DepositEventAction.FTD, depositInfo);
    };
    TrackingServiceV2.prototype.trackNewDepositingCustomer = function (depositInfo) {
        this.trackDepositAction(tracking_v2_interface_1.DepositEventAction.NDC, depositInfo);
    };
    /*
     * Withdrawals
     */
    TrackingServiceV2.prototype.trackWithdrawalIntent = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.WITHDRAWAL,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.WITHDRAWAL,
            eventAction: tracking_v2_interface_1.WithdrawalEventAction.OPEN,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackWithdrawalStarted = function (method) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.WITHDRAWAL,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.WITHDRAWAL,
            eventAction: tracking_v2_interface_1.WithdrawalEventAction.STARTED,
            eventLabel: null,
            value: method,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackWithdrawalAttempt = function (withdrawalInfo) {
        this.trackWithdrawal(tracking_v2_interface_1.WithdrawalEventAction.ATTEMPT, withdrawalInfo);
    };
    TrackingServiceV2.prototype.trackWithdrawalSuccess = function (withdrawalInfo) {
        this.trackWithdrawal(tracking_v2_interface_1.WithdrawalEventAction.WITHDRAW, withdrawalInfo);
    };
    TrackingServiceV2.prototype.trackWithdrawalError = function (withdrawalInfo) {
        this.trackWithdrawal(tracking_v2_interface_1.WithdrawalEventAction.ERROR, withdrawalInfo);
    };
    /**
     * Quick deposit
     */
    TrackingServiceV2.prototype.trackQDIntent = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.QUICK_DEPOSIT,
            eventAction: tracking_v2_interface_1.QuickDepositEventAction.INTENT,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackQDAttempt = function (value) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.QUICK_DEPOSIT,
            eventAction: tracking_v2_interface_1.QuickDepositEventAction.ATTEMPT,
            eventLabel: null,
            value: value,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackQDSuccess = function (value) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.QUICK_DEPOSIT,
            eventAction: tracking_v2_interface_1.QuickDepositEventAction.SUCCESS,
            eventLabel: null,
            value: value,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackQDError = function (value, eventLabel) {
        if (eventLabel === void 0) { eventLabel = null; }
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.QUICK_DEPOSIT,
            eventAction: tracking_v2_interface_1.QuickDepositEventAction.ERROR,
            eventLabel: eventLabel,
            value: value,
        };
        this.track(event);
    };
    /*
     * Search
     */
    TrackingServiceV2.prototype.trackSearch = function (searchQuery) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.SEARCH,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.SEARCH,
            eventAction: null,
            eventLabel: null,
            value: searchQuery,
        };
        this.track(event);
    };
    /*
     * KYC
     */
    TrackingServiceV2.prototype.trackIdDocumentUploaded = function (idDocType) {
        this.trackDocumentUploaded(getAmlStatus_1.DocumentType.PHOTO_ID, idDocType);
    };
    TrackingServiceV2.prototype.trackAddressDocumentUploaded = function () {
        this.trackDocumentUploaded(getAmlStatus_1.DocumentType.ADDRESS);
    };
    TrackingServiceV2.prototype.trackPaymentDocumentUploaded = function () {
        this.trackDocumentUploaded(getAmlStatus_1.DocumentType.PAYMENT);
    };
    /*
     * RG Questionnaire
     */
    TrackingServiceV2.prototype.trackRgQuestionnaireSubmit = function (score, maxScore) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.RG_QUESTIONNAIRE,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.RG_QUESTIONNAIRE,
            eventAction: 'Submit',
            eventLabel: null,
            value: score,
            maxScore: maxScore,
        };
        this.track(event);
    };
    /*
     * Track seasonal gift selection
     */
    TrackingServiceV2.prototype.trackSeasonalGiftSelection = function (giftIndex) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.SEASONAL_EVENT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.SEASONAL_EVENT,
            eventAction: tracking_v2_interface_1.SeasonalEventAction.GIFT_SELECTED,
            eventLabel: null,
            value: giftIndex + 1,
        };
        this.track(event);
    };
    /*
     * Track seasonal gift closing
     */
    TrackingServiceV2.prototype.trackSeasonalEventClosed = function (stage) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.SEASONAL_EVENT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.SEASONAL_EVENT,
            eventAction: tracking_v2_interface_1.SeasonalEventAction.CLOSE,
            eventLabel: null,
            value: stage + 1,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackSeasonalEventCompleted = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.SEASONAL_EVENT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.SEASONAL_EVENT,
            eventAction: tracking_v2_interface_1.SeasonalEventAction.CTA,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackMembershipRegisterAttempt = function (utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.MEMBERSHIP_REGISTRATION,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.MEMBERSHIP_REGISTRATION,
            eventAction: tracking_v2_interface_1.MembershipRegistrationEventAction.ATTEMPT,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackMembershipRegisterClosed = function (step, utm, btag) {
        this.trackRegisterClosed(step, utm, btag);
    };
    TrackingServiceV2.prototype.trackRegisterClosed = function (step, utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.REGISTER_CLOSED,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.MEMBERSHIP_REGISTRATION,
            eventAction: tracking_v2_interface_1.MembershipRegistrationEventAction.CLOSE,
            eventLabel: step,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackMembershipRegisterFlow = function (step, utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.REGISTER_FLOW,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.MEMBERSHIP_REGISTRATION,
            eventAction: step,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackMembershipRegisterSubmittedAndAccepted = function (utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.REGISTER_SUBMITTED_AND_ACCEPTED,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.MEMBERSHIP_REGISTRATION,
            eventAction: tracking_v2_interface_1.MembershipRegistrationEventAction.ACCEPTED,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackConfirmedAndActivated = function (utm, btag) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.REGISTER_CONFIRMED_AND_ACTIVATED,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.MEMBERSHIP_REGISTRATION,
            eventAction: tracking_v2_interface_1.MembershipRegistrationEventAction.ACCEPTED,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackUpdateProfile = function () {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.UPDATE_PROFILE,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.PROFILE_UPDATE,
            eventAction: tracking_v2_interface_1.MembershipRegistrationEventAction.SUBMIT,
            eventLabel: null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackDocumentUploaded = function (docType, idDocType) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.KYC,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.UPLOAD_DOCUMENT,
            eventAction: docType,
            eventLabel: idDocType || null,
            value: null,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackWithdrawal = function (action, withdrawalInfo) {
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.WITHDRAWAL,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.WITHDRAWAL,
            eventAction: action,
            eventLabel: null,
            value: withdrawalInfo.amount,
            valueEUR: this.convertBalance(withdrawalInfo.amount),
            currency: withdrawalInfo.currency,
            withdrawalProvider: withdrawalInfo.method,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackDepositAction = function (action, depositInfo) {
        var _a;
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.DEPOSIT,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.DEPOSIT,
            eventAction: action,
            eventLabel: null,
            value: depositInfo.amount,
            valueEUR: this.convertBalance(depositInfo.amount),
            currency: depositInfo.currency,
            depositCount: ((_a = this.user) === null || _a === void 0 ? void 0 : _a.depositCount) || 0,
            paymentProvider: depositInfo.method,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackRegistrationAction = function (action, utm, btag) {
        var eventName = tracking_v2_interface_1.TrackEvent.REGISTER_ATTEMPT;
        if (action.includes('resend')) {
            eventName = tracking_v2_interface_1.TrackEvent.REGISTER_RESEND_LINK;
        }
        if (action.includes('Accepted')) {
            this.trackMembershipRegisterSubmittedAndAccepted(utm, btag);
        }
        if (action.includes('NRC')) {
            this.trackConfirmedAndActivated(utm, btag);
        }
        var event = {
            userId: this.getUserId(),
            event: eventName,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.REGISTRATION,
            eventAction: action,
            eventLabel: null,
            value: null,
            affiliateId: btag || '',
            utm: utm,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackGame = function (gameInfo, action) {
        var _a, _b;
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.GAME,
            eventCategory: gameInfo.isLive
                ? tracking_v2_interface_1.TrackEventCategory.LIVE_CASINO
                : tracking_v2_interface_1.TrackEventCategory.CASINO,
            eventAction: action,
            eventLabel: gameInfo.slug,
            value: ((_a = this.balance) === null || _a === void 0 ? void 0 : _a.balance) || 0,
            valueEUR: this.convertBalance(((_b = this.balance) === null || _b === void 0 ? void 0 : _b.balance) || 0),
            gameId: gameInfo.gameId,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.trackBalance = function (type) {
        var _a, _b;
        var balance = ((_a = this.balance) === null || _a === void 0 ? void 0 : _a.balance) || 0;
        var event = {
            userId: this.getUserId(),
            event: tracking_v2_interface_1.TrackEvent.BALANCE,
            eventCategory: tracking_v2_interface_1.TrackEventCategory.BALANCE,
            eventAction: type,
            eventLabel: null,
            value: balance,
            valueEUR: this.convertBalance(balance),
            currency: (_b = this.user) === null || _b === void 0 ? void 0 : _b.currency,
        };
        this.track(event);
    };
    TrackingServiceV2.prototype.updateUserDetails = function () {
        window.userDetails = tslib_1.__assign(tslib_1.__assign({}, this.getUserInfo()), this.getPageInfo());
    };
    TrackingServiceV2.prototype.getUserId = function () {
        return this.user && this.user.id ? this.user.id : '';
    };
    TrackingServiceV2.prototype.getUserInfo = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            userId: ((_a = this.user) === null || _a === void 0 ? void 0 : _a.userId) || '',
            username: ((_b = this.user) === null || _b === void 0 ? void 0 : _b.userName) || '',
            currency: ((_c = this.user) === null || _c === void 0 ? void 0 : _c.currency) || '',
            balance: ((_d = this.balance) === null || _d === void 0 ? void 0 : _d.balance) || 0,
            balanceEur: this.convertBalance(((_e = this.balance) === null || _e === void 0 ? void 0 : _e.balance) || 0),
            bonus: (_f = this.balance) === null || _f === void 0 ? void 0 : _f.bonusBalance,
            affiliateId: ((_g = this.user) === null || _g === void 0 ? void 0 : _g.affiliate) || null,
        };
    };
    TrackingServiceV2.prototype.getPageInfo = function () {
        return {
            currentPage: this.page ||
                window.location.href.replace(window.location.origin, ''),
            licence: this.jurisdiction,
            language: config_1.magicConfig.language,
        };
    };
    TrackingServiceV2.prototype.convertSessionStatus = function (code) {
        switch (code) {
            case events_1.SessionCode.EXPIRED:
                return 'expired';
            case events_1.SessionCode.LOGGED_IN:
                return 'logged-in';
            case events_1.SessionCode.LOGGED_OFF:
                return 'logged-out';
            case events_1.SessionCode.TERMINATED_BY_ANOTHER_LOGIN:
                return 'terminated-by-another-login';
            case events_1.SessionCode.TERMINATED_BY_PRESET_TIME:
                return 'terminated-by-preset-time';
            case events_1.SessionCode.TERMINATED_BY_SELF_EXCLUSION:
                return 'terminated-by-self-exclusion';
            case events_1.SessionCode.TERMINATED_BY_GEO_LOCATION:
                return 'terminated-by-geo-location';
            default:
                return 'unknown';
        }
    };
    TrackingServiceV2.prototype.convertBalance = function (value) {
        var _a;
        var _b;
        var currency = (_b = this.user) === null || _b === void 0 ? void 0 : _b.currency;
        if (!currency) {
            return value;
        }
        var mappings = (_a = {},
            _a[signup_1.Currency.DKK] = 10,
            _a[signup_1.Currency.SEK] = 10,
            _a[signup_1.Currency.NOK] = 10,
            _a);
        var divider = mappings[currency] || 1;
        return value / divider;
    };
    return TrackingServiceV2;
}());
exports.TrackingServiceV2 = TrackingServiceV2;
